import { getStackTrace, log } from '@src/Log.init';
import Dinero from 'dinero.js';
import { zero } from 'helpers/currency';
import { rootApi } from './root.api';

export const cashManagementApi = rootApi.injectEndpoints({
  tagTypes: ['CashManagement'],
  endpoints: (builder) => ({
    searchCashCounts: builder.query({
      query: (criteria) => {
        const queryString = Object.keys(criteria)
          .map((key) => `${key}=${criteria[key]}`)
          .join('&');
        return {
          url: `cashcount?${queryString}`,
          method: 'GET',
        };
      },
      providesTags: ['CashManagement'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'CashManagement',
          message: 'searchCashCounts: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'CashManagement',
            message: 'searchCashCounts: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'searchCashCounts: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
      transformResponse: (response) => {
        log.debug({
          message_type: 'Location',
          message: 'searchDevices: transformResponse',
          data: response,
        });

        const res = response[0].data.map((count) => {
          count.amount =
            count.amount && count.amount.amount ? Dinero(count.amount) : zero;
          count.expected =
            count.expected && count.expected.amount
              ? Dinero(count.expected)
              : zero;
          count.delta =
            count.delta && count.delta.amount ? Dinero(count.delta) : zero;
          return count;
        });

        return { metadata: response[0].metadata[0], data: res };
      },
    }),
    getCountHistory: builder.query({
      query: (countId) => ({
        url: `counthistory/${countId}`,
        method: 'GET',
      }),
      providesTags: ['CashManagement'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'CashManagement',
          message: 'getCountHistory: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'CashManagement',
            message: 'getCountHistory: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getCountHistory: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
  }),
});

export const { useLazySearchCashCountsQuery, useLazyGetCountHistoryQuery } =
  cashManagementApi;
